// src/app/router/AppRouter.jsx
import React, { Suspense, memo } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '@app/layouts/MainLayout';
import BackgroundLayout from '@app/layouts/BackgroundLayout';
import { routeConfig } from './config';
import { ProtectedRoute } from './ui/ProtectedRoute';
import { RootRedirect } from './ui/RootRedirect';
import { PageLoader } from './ui/PageLoader';
import StreamWidgetPage from '@pages/WidgetPage';

import { TooltipProvider } from '@app/providers';

const AppRouter = () => {
  return (
    <Routes>
      {/* 📺 Публичный виджет - БЕЗ ФОНОВ И ЛЕЙАУТОВ */}
      <Route path="/widgets/stream/:token" element={<StreamWidgetPage />} />

      {/* 🏠 Основной сайт - С ФОНОМ, СЕТКОЙ И ТУЛТИПАМИ */}
      <Route element={
        <TooltipProvider>
          <BackgroundLayout>
            <MainLayout />
          </BackgroundLayout>
        </TooltipProvider>
      }>
        {routeConfig.map(({ path, element, authRequired, publicOnly, isRoot }) => {
          if (isRoot) {
            return <Route key={path} path={path} element={<RootRedirect />} />;
          }

          let routeElement = (
            <Suspense fallback={<PageLoader />}>
              {element}
            </Suspense>
          );

          if (authRequired || publicOnly) {
            routeElement = (
              <ProtectedRoute publicOnly={publicOnly}>
                {routeElement}
              </ProtectedRoute>
            );
          }

          return <Route key={path} path={path} element={routeElement} />;
        })}
      </Route>

      {/* 404 */}
      <Route path="*" element={
        <BackgroundLayout>
          <div className="flex-center flex-col" style={{ padding: '60px 20px', minHeight: '100vh' }}>
            <h1 className="text-3xl text-danger">404</h1>
            <p className="text-md" style={{ margin: 'var(--spacing-lg) 0' }}>СТРАНИЦА НЕ НАЙДЕНА</p>
            <a href="/" className="retro-button">ВЕРНУТЬСЯ НА ГЛАВНУЮ</a>
          </div>
        </BackgroundLayout>
      } />
    </Routes>
  );
};

export default memo(AppRouter);
